var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"plugin-about-media-item swiper-slide",attrs:{"href":_vm.url,"target":"_blank"}},[_c('img',{staticClass:"plugin-about-media-item__image",attrs:{"src":_vm.resizedImage,"loading":"lazy","alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }